import { useCallback, useEffect, useRef, useState } from "react";
import { ConfirmationDialogHost, type ConfirmationOptions } from "@/frontend/components/ui/confirmation-dialog";

export function useConfirmationDialog(scopeKey?: string) {
  const [options, setOptions] = useState<ConfirmationOptions | null>(null);
  const resolveRef = useRef<((confirmed: boolean) => void) | null>(null);

  useEffect(() => () => {
    resolveRef.current?.(false);
    resolveRef.current = null;
  }, []);

  const requestConfirmation = useCallback((next: ConfirmationOptions): Promise<boolean> => {
    // A second click must not replace or approve an outstanding decision.
    if (resolveRef.current) return Promise.resolve(false);
    return new Promise((resolve) => {
      resolveRef.current = resolve;
      setOptions(next);
    });
  }, []);

  const settle = useCallback((confirmed: boolean) => {
    const resolve = resolveRef.current;
    resolveRef.current = null;
    setOptions(null);
    resolve?.(confirmed);
  }, []);

  const confirmationDialog = <ConfirmationDialogHost key={scopeKey} options={options} onResolve={settle} />;

  return { requestConfirmation, confirmationDialog };
}
